import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { frameId: String }

  initialize() {
    this.url = this.element.getAttribute("href");
  }

  open(event) {
    event.preventDefault();
    const dialog = this.insertContainer();
    dialog.showModal();
  }

  insertContainer() {
    const content = `
      <div class="fixed inset-0 bg-black bg-opacity/50 flex items-center justify-center z-50">
        <dialog class="modal w-full md:max-w-lg lg:max-w-xl p-4 bg-white rounded-lg shadow-lg" id="turbo-dialog">
          <div class="relative">
            <button type="button" class="btn rounded-full p-4 absolute top-0 right-0" data-behavior="cancel" autofocus>
              <i class="icon-x pointer-events-none"></i>
            </button>
            <div class="overflow-y-auto p-4">
              <turbo-frame id="${this.frameIdValue}" src="${this.url}">
                <i class="loading loading-dots loading-sm"></i>
              </turbo-frame>
            </div>
          </div>
        </dialog>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', content);
    document.activeElement.blur();

    const dialog = document.getElementById("turbo-dialog");

    dialog.addEventListener("click", (event) => {
      if (event.target.hasAttribute("data-behavior") && event.target.getAttribute("data-behavior") === "cancel") {
        event.preventDefault();
        dialog.close();
      }
    });

    dialog.addEventListener("close", () => {
      dialog.parentElement.remove();
    });

    return dialog;
  }
}
